import { useLocalStorage } from "@hooks/use-local-storage";
import { SESSION_VALUE_KEYS } from "src/constants";

/*
Store a value that will be cleared when the user's session ends (i.e., they log
out or their JWT expires).

Note that this does NOT use sessionStorage. We want these values to persist as
long as their JWT is still valid, even if they close and reopen the app.
*/
export const useSessionValue = (
  keyName,
  { defaultValue, expiresAt, expiredCb } = {},
) => {
  console.assert(
    Object.values(SESSION_VALUE_KEYS).includes(keyName),
    `Unknown session value key: ${keyName}`,
  );

  return useLocalStorage(keyName, {
    defaultValue,
    expiresAt,
    expiredCb,
  });
};

export const useClearSessionValues = () => {
  const setValues = [];
  for (const keyName of Object.values(SESSION_VALUE_KEYS)) {
    // SESSION_VALUE_KEYS is a constant, so calling a hook in a loop like this
    // _should_ be fine...
    const [, setValue] = useLocalStorage(keyName);
    setValues.push(setValue);
  }

  return () => {
    for (const setValue of setValues) {
      setValue();
    }
  };
};
